// import { Line } from '@ant-design/plots';
// import { Line } from 'react-chartjs-2';
// import { Row, Col } from 'antd';

import {
	Chart as Chartjs,
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend,
} from 'chart.js';
import moment from 'moment';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useAppSelector } from '../../methods/redux/hooks';

import { commas } from '../../methods/utils/general-utils';
// import ViewApyByDate from './ViewApyByDate';

Chartjs.register(
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend
);

const Styles = styled.div`
	& .top {
		display: flex;
		justify-content: space-between;
	}
	& .info {
		display: grid;
		grid-template-columns: 1fr;

		@media (min-width: 768px) {
			grid-template-columns: 1fr 2fr;
			align-items: center;
		}
	}
	& .apy {
		color: green;
		font-size: 16px;
	}
	& .last-updated {
		font-size: 11.5px;
	}

	& .estimated-payout {
		& > * {
			display: inline-block;
			padding: 5px 20px 5px 1px;

			& .label {
				font-size: 10px;
				font-style: italic;
			}
		}
	}
`;

const ViewTodayApy = () => {
	const { todaysApy, todayApyArray } = useAppSelector((store) => store.general);

	// const hourLabel = todayApyArray.map(
	// 	(hourData: any) => `${String(hourData.hour)}:00h`
	// );

	const hourlApyValue = todayApyArray.map((hourData: any) =>
		String(Number(hourData.apy) * 100)
	);

	const apyAverage =
		hourlApyValue.reduce((prev, current: any) => prev + Number(current), 0) /
		hourlApyValue.length;

	return (
		<Styles>
			<div className="top">
				<h2>Today&apos;s APY</h2>
				<Link to="/reports/apy-history">View APY History</Link>
			</div>

			<div style={{ display: 'flex', alignItems: 'center' }}>
				<h2 style={{ margin: '8px' }}>Payout Apy:</h2>
				<p className="apy" style={{ fontSize: '20px' }}>
					{commas(Number(todaysApy?.apy) * 100)}%
				</p>
			</div>

			<div style={{ display: 'flex', alignItems: 'center' }}>
				<h2 style={{ margin: '8px' }}>Fluid Apy:</h2>
				<p style={{ fontSize: '20px' }}>
					{commas(Number(todaysApy?.fluidApy) * 100)}%
				</p>
			</div>
			<div style={{ display: 'flex', alignItems: 'center' }}>
				<h2 style={{ margin: '8px' }}>xAuto Apy:</h2>
				<p style={{ fontSize: '20px' }}>
					{commas(Number(todaysApy?.xAutoApy) * 100)}%
				</p>
			</div>

			<br />

			<div className="info">
				<div>
					{/* <p className="apy">
						<strong>{commas(Number(todaysApy?.apy) * 100)}%</strong>
					</p> */}
					<p className="last-updated">
						{todaysApy.updatedAt ? (
							<span>
								Updated: {moment(todaysApy.updatedAt).format('lll')} (
								{moment(todaysApy.updatedAt).fromNow()})
							</span>
						) : (
							'Not yet updated today'
						)}
					</p>
					<br />
					<p>
						APY average for today is <strong>{commas(apyAverage)}%</strong>,
						updated by{' '}
						{todaysApy.lastUpdatedByUserId?.username ||
							todaysApy.lastUpdatedByUserId?.email}
					</p>
					<Link
						style={{ textTransform: 'uppercase' }}
						to="/settings/general#daily-apy"
					>
						Settings
					</Link>
				</div>
			</div>
		</Styles>
	);
};

export default ViewTodayApy;
